import { IcoEdit } from 'icone';
import React, { useContext, useMemo, useState } from 'react';
import { Button, Modal, OverlayTrigger, Tab, Tabs, Tooltip } from 'react-bootstrap';
import { ContinuousReportingType } from '../ContinuousReporting';
import DataHeader from 'components/DataHeader';
import ContinuousReportingDeliverablesAndMilestones from './ContinuousReportingDeliverablesAndMilestones';
import ContinuousReportingValidateModal from './ContinuousReportingValidateModal';
import ContinuousReportingStatus from './ContinuousReportingStatus';
import CheckDocTab from 'components/projectStatements/CheckDocTab';
import ContinuousReportingSummary from './ContinuousReportingSummary';
import { UserContext } from '@components/contexts/UserProvider';
import { useHasPermission } from '@lib/hooks/useHasPermission';

interface ContinuousReportingUpdateModalProps {
	data: ContinuousReportingType;
	fetchData: () => void;
	isEnabledToView: boolean;
	state: 'DRAFT' | 'VALIDATED';
	isProjectWp: boolean;
}

const ContinuousReportingUpdateModal: React.FC<ContinuousReportingUpdateModalProps> = ({
	data,
	fetchData,
	isEnabledToView,
	state,
	isProjectWp,
}) => {
	const canViewHistoryIntegration = useHasPermission(['view-sal-history-integration'], 'all');
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [activeKey, setActiveKey] = useState(state === 'VALIDATED' ? 'status' : 'output');
	const { isPartnerUser, isCoordinator } = useContext(UserContext);
	const hasPartnerAccess = useMemo(() => (isProjectWp ? isPartnerUser : isCoordinator), [isPartnerUser, isCoordinator, isProjectWp]);

	const [inputValues, setInputValues] = useState({
		contextAndObjectives: data.contextAndObjectives || '',
		expectedOutcomes: data.expectedOutcomes || '',
		workPerformedAndResults: data.workPerformedAndResults || '',
		projectPolicyRelevance: data.projectPolicyRelevance || '',
	});

	const headerElements = [
		{
			name: <span className="text-nowrap">ID</span>,
			value: data.continuosReportingNumber,
		},
	];
	const tabs = [
		...(state === 'VALIDATED'
			? [
					{
						eventKey: 'status',
						title: 'Status',
						content: <ContinuousReportingStatus data={data} canEdit={isEnabledToView || isProjectWp} />,
					},
				]
			: []),
		...(state === 'VALIDATED' && canViewHistoryIntegration
			? [
					{
						eventKey: 'integration',
						title: 'Integrazione',
						content: (
							<CheckDocTab
								detail={data}
								tab={activeKey}
								conditionalitiesFilterCodes={['Integrazione']}
								isValidated={state === 'VALIDATED'}
								handleChanges={() => {}}
								setDetail={() => {}}
								isProjectWp={isProjectWp}
								isEnabledToView={isEnabledToView || hasPartnerAccess}
							/>
						),
					},
				]
			: []),
		{
			eventKey: 'output',
			title: 'Output',
			content: <ContinuousReportingDeliverablesAndMilestones data={data} isEnabledToView={isEnabledToView} state={state} />,
		},
		// ...(isCoordinator || isEnabledToView
		// 	? [
		{
			eventKey: 'summary',
			title: 'Summary',
			content: (
				<ContinuousReportingSummary
					data={data}
					state={state}
					activeKey={activeKey}
					inputValues={inputValues}
					setInputValues={setInputValues}
					isEnabledToView={isEnabledToView || hasPartnerAccess}
				/>
			),
		},
		// 	]
		// : []),
	];
	return (
		<>
			<OverlayTrigger placement="top" overlay={(props) => <Tooltip {...props}>Modifica</Tooltip>}>
				<span>
					<Button
						variant="link"
						onClick={() => {
							setIsModalOpen(true);
						}}
					>
						<IcoEdit className="second-color ico-small edit" />
					</Button>
				</span>
			</OverlayTrigger>
			<Modal
				size="lg"
				show={isModalOpen}
				onHide={() => {
					setIsModalOpen(false);
					setActiveKey(state === 'VALIDATED' ? 'status' : 'output');
					fetchData();
				}}
				fullscreen
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<DataHeader
							data={headerElements}
							customStyle={{
								margin: 0,
								paddingTop: '5px',
								paddingBottom: 0,
								marginLeft: '15px',
							}}
						/>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{/* {state === 'DRAFT' ? (
						<ContinuousReportingDeliverablesAndMilestones data={data} isCoordinator={isCoordinator} isEnabledToView={isEnabledToView} state={state} />
					) : null}
					{state === 'VALIDATED' ? ( */}
					<Tabs className="mb-4" variant="pills" activeKey={activeKey} onSelect={(key) => setActiveKey(key)} fill>
						{tabs.map((tab) => (
							<Tab key={tab.eventKey} eventKey={tab.eventKey} title={tab.title}>
								{activeKey === tab.eventKey ? tab.content : null}
							</Tab>
						))}
					</Tabs>
					{/* ) : null} */}
				</Modal.Body>
				{state === 'DRAFT' ? (
					<Modal.Footer className="d-flex justify-content-center">
						{isEnabledToView ? <ContinuousReportingValidateModal data={data} fetchData={fetchData} /> : null}
					</Modal.Footer>
				) : null}
			</Modal>
		</>
	);
};

export default ContinuousReportingUpdateModal;
